import { IWheelProps } from '~/actions/extraHTML/wheelOfFortune';
import {
  desktopRadius,
  mobileRadius, noRotationElementsClass,
  rotationElementsClass,
} from '~/actions/extraHTML/wheelOfFortune/const';
import { arrows } from '~/actions/extraHTML/wheelOfFortune/html/noRotationElements/arrows';
import {
  decorativeElements
} from '~/actions/extraHTML/wheelOfFortune/html/noRotationElements/decorativeElements';
import { winArrow } from '~/actions/extraHTML/wheelOfFortune/html/noRotationElements/winArrow';
import { wheelSectors } from '~/actions/extraHTML/wheelOfFortune/html/rotationElements/wheelSectors';
import { initAnimationEndFunctions } from '~/actions/extraHTML/wheelOfFortune/javascript';

export const getHtml = (
  iterator: number,
  prefix: string,
  isMobile: boolean,
  wheelParams: IWheelProps
) => {
  const wheelFillerClass = isMobile
    ? `${prefix}mobile_wheel_filler`
    : `${prefix}desktop_wheel_filler`;

  const wheelClass = isMobile
    ? `${prefix}wheel_notification_mobile`
    : `${prefix}wheel_notification_desktop`;

  const radius = isMobile ? mobileRadius : desktopRadius;

  setTimeout(() => {
    initAnimationEndFunctions({ prefix, iterator, wheelParams, isMobile });
  }, 500);

  return `<div class='${wheelFillerClass}'>
    <div class='${wheelClass}'>
      <div class='${noRotationElementsClass}'>
        ${decorativeElements(radius)}
        ${winArrow()}
        ${arrows(wheelParams.sectors, radius)}
      </div>
      <div class='${rotationElementsClass}'>
        ${wheelSectors(wheelParams, radius)}
      </div>
    </div>
</div>`;
};
